import React from 'react';
import styled from 'react-emotion';
import SortOrder from './SortOrder';
import { ListItem } from '@jetshop/ui/Select/Components';
import { ReactComponent as Check } from '@jetshop/ui/svg/Check.svg';
const StyledListItem = styled(ListItem) `
  padding: 0 1rem;
`;
const SortOrderList = ({ sortOrders }) => {
    return (React.createElement(SortOrder, { sortOrders: sortOrders }, ({ changeSortOrder, direction, sortOrder, mappedSortOrder }) => mappedSortOrder.map(order => (React.createElement(StyledListItem, { type: "button", key: `${order.value}-${order.direction}`, onClick: () => {
            changeSortOrder(order.value, order.direction);
        } },
        order.text,
        direction === order.direction && sortOrder === order.value && (React.createElement(Check, null)))))));
};
export default SortOrderList;
//# sourceMappingURL=SortOrderList.js.map